<template>
  <div class="legal-page">
    <div class="card">
      <header class="page-header">
        <h1 class="h1">
          Datenschutzerklärung für das Online-Portal
        </h1>
      </header>

      <section>
        <p class="datenschutz-intro">
          In dieser Datenschutzerklärung informieren wir Sie über die Verarbeitung personenbezogener Daten bei der
          Nutzung
          unseres Online-Portals (Login-Bereich) der <strong>Freien Naturschule Barnim</strong>.
          Es werden ausschließlich solche Daten verarbeitet, die für den technischen Betrieb,
          die sichere Bereitstellung des Login-Bereichs und die Nutzung durch berechtigte Personen erforderlich sind.
        </p>

        <h3>1. Verantwortlicher</h3>
        <p>
          Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:
        </p>
        <p>
          <strong>wild frei grün e.V.</strong><br>
          Bahnhofstraße 81a<br>
          16359 Biesenthal<br>
          Deutschland
        </p>
        <p>
          Vertreten durch den Vorstand:<br>
          Monique Reiter, Doreen Buske, Andreas Nick
        </p>
        <p>
          E-Mail: <a href="mailto:kontakt@wildfreigruen.de">kontakt@wildfreigruen.de</a>
        </p>

        <h3>2. Datenverarbeitung beim Aufruf des Online-Portals (Server-Logfiles)</h3>
        <p>
          Beim rein informatorischen Aufruf der öffentlich erreichbaren Login-Seite unseres Online-Portals werden durch
          den von uns eingesetzten Server automatisch Informationen erfasst, die Ihr Browser an unseren Server
          übermittelt.
          Diese Informationen werden in sogenannten Server-Logfiles gespeichert.
        </p>
        <p>
          Erfasst werden insbesondere:
        </p>
        <ul>
          <li>IP-Adresse des anfragenden Endgeräts</li>
          <li>Datum und Uhrzeit der Anfrage</li>
          <li>Zeitzonendifferenz zur Greenwich Mean Time (GMT)</li>
          <li>aufgerufene Seite / konkreter Pfad (URL)</li>
          <li>Zugriffsstatus / HTTP-Statuscode</li>
          <li>jeweils übertragene Datenmenge</li>
          <li>Website, von der die Anforderung kommt (Referrer-URL, sofern übermittelt)</li>
          <li>verwendeter Browsertyp und Version</li>
          <li>Betriebssystem und dessen Oberfläche</li>
        </ul>
        <p>
          Die Verarbeitung dieser Daten ist technisch erforderlich, um Ihnen die Login-Seite unseres Portals anzuzeigen,
          die Stabilität und Sicherheit des Systems zu gewährleisten und gegebenenfalls Angriffe erkennen und verfolgen
          zu können.
        </p>
        <p>
          Rechtsgrundlage für diese Datenverarbeitung ist Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO
          (berechtigtes Interesse an einer sicheren und stabilen Bereitstellung des Online-Angebots).
        </p>
        <p>
          Die Logfiles werden nur so lange gespeichert, wie es für die genannten Zwecke erforderlich ist.
          Anschließend werden sie gelöscht oder anonymisiert.
        </p>

        <h3>3. Technisch notwendige Cookies</h3>
        <p>
          Auf unserem Online-Portal werden ausschließlich technisch notwendige Cookies eingesetzt.
          Diese Cookies sind erforderlich, um die Funktionalität des Login-Bereichs bereitzustellen,
          insbesondere um Sitzungen zu verwalten (Session-Management) und Sicherheitsmechanismen
          (z.&nbsp;B. Schutz vor CSRF-Angriffen) zu gewährleisten.
        </p>
        <p>
          Hierbei kann es sich insbesondere um folgende Arten von Cookies handeln:
        </p>
        <ul>
          <li>
            <strong>Session-Cookies</strong> zur Wiedererkennung eines eingeloggten Nutzerkontos während einer Sitzung
          </li>
          <li>
            <strong>Sicherheits-Cookies</strong> (z.&nbsp;B. CSRF-Tokens) zum Schutz vor missbräuchlichen Anfragen
          </li>
        </ul>
        <p>
          Diese Cookies speichern in der Regel keine Klardaten wie Namen oder E-Mail-Adressen, sondern lediglich
          technisch notwendige Kennungen (z.&nbsp;B. zufällig generierte Session-IDs).
        </p>
        <p>
          Technisch notwendige Cookies werden nach Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO verarbeitet
          (berechtigtes Interesse an der sicheren und funktionsfähigen Bereitstellung des Online-Portals).
          Eine gesonderte Einwilligung über ein Cookie-Banner ist hierfür nicht erforderlich.
        </p>
        <p>
          Es werden keine Cookies zu Analyse-, Tracking- oder Marketingzwecken eingesetzt.
        </p>

        <h3>4. Nutzung des Login-Bereichs</h3>
        <p>
          Zur Nutzung des geschützten Bereichs des Online-Portals ist eine Anmeldung (Login) erforderlich.
          In diesem Zusammenhang werden personenbezogene Daten verarbeitet, die für die Verwaltung der Zugänge
          und die Bereitstellung der jeweiligen Funktionen notwendig sind.
        </p>
        <p>
          Hierzu gehören insbesondere:
        </p>
        <ul>
          <li>Benutzerkennung (z.&nbsp;B. Benutzername oder E-Mail-Adresse)</li>
          <li>ein dem Nutzer zugeordnetes (verschlüsselt gespeichertes) Passwort</li>
          <li>ggf. Rollen- oder Rechtezuordnungen innerhalb des Portals</li>
          <li>Meta-Daten zur Nutzung des Kontos (z.&nbsp;B. Zeitpunkte des letzten Logins)</li>
        </ul>
        <p>
          Die Verarbeitung dieser Daten erfolgt, um den Zugang zum Online-Portal zu ermöglichen und
          die für die jeweilige Rolle vorgesehenen Funktionen bereitzustellen (z.&nbsp;B. Informationszugriff,
          interne Kommunikation oder Verwaltungsvorgänge im Rahmen des Schulbetriebs).
        </p>
        <p>
          Rechtsgrundlage hierfür ist in der Regel Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;b DSGVO
          (Erfüllung eines Vertrags bzw. vorvertraglicher Maßnahmen) sowie,
          soweit schulorganisatorische Pflichten erfüllt werden, Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO
          (berechtigtes Interesse an der Organisation und Durchführung des Schulbetriebs).
        </p>

        <h3>5. Hosting</h3>
        <p>
          Unser Online-Portal wird bei einem externen Dienstleister (Hosting-Anbieter) betrieben.
          Der Betrieb der Server, auf denen dieses Portal technisch vorgehalten wird, erfolgt im Auftrag
          des Verantwortlichen.
        </p>
        <p>
          Im Rahmen des Hostings werden insbesondere die in Abschnitt&nbsp;2 (Server-Logfiles) genannten Daten
          sowie die technischen Daten verarbeitet, die für den Betrieb des Portals notwendig sind.
        </p>
        <p>
          Die Verarbeitung erfolgt auf Grundlage eines Auftragsverarbeitungsvertrages gemäß Art.&nbsp;28 DSGVO.
        </p>

        <h3>6. Weitergabe von Daten</h3>
        <p>
          Eine Übermittlung personenbezogener Daten an Dritte erfolgt nur,
          soweit dies für den Betrieb des Online-Portals erforderlich ist,
          eine gesetzliche Verpflichtung besteht oder eine Einwilligung vorliegt.
          Eine Weitergabe zu Zwecken der Werbung, des Profilings oder des Marketings erfolgt nicht.
        </p>

        <h3>7. Speicherdauer</h3>
        <p>
          Personenbezogene Daten werden nur so lange gespeichert, wie es für die jeweiligen Zwecke der Verarbeitung
          erforderlich ist oder wie es gesetzliche Aufbewahrungspflichten vorsehen.
          Dies gilt insbesondere für Daten, die im Zusammenhang mit der Nutzung des Login-Bereichs verarbeitet werden.
          Nach Wegfall des Verarbeitungszwecks bzw. Ablauf gesetzlicher Aufbewahrungsfristen
          werden die Daten gelöscht oder anonymisiert.
        </p>

        <h3>8. Rechte der betroffenen Personen</h3>
        <p>
          Ihnen stehen als betroffene Person im Sinne der DSGVO folgende Rechte zu:
        </p>
        <ul>
          <li><strong>Recht auf Auskunft</strong> nach Art.&nbsp;15 DSGVO</li>
          <li><strong>Recht auf Berichtigung</strong> nach Art.&nbsp;16 DSGVO</li>
          <li><strong>Recht auf Löschung</strong> („Recht auf Vergessenwerden“) nach Art.&nbsp;17 DSGVO</li>
          <li><strong>Recht auf Einschränkung der Verarbeitung</strong> nach Art.&nbsp;18 DSGVO</li>
          <li><strong>Recht auf Datenübertragbarkeit</strong> nach Art.&nbsp;20 DSGVO</li>
          <li>
            <strong>Recht auf Widerspruch</strong> gegen die Verarbeitung nach Art.&nbsp;21 DSGVO,
            soweit die Verarbeitung auf Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;e oder lit.&nbsp;f DSGVO beruht
          </li>
        </ul>
        <p>
          Soweit die Verarbeitung auf einer Einwilligung beruht, haben Sie das Recht,
          eine erteilte Einwilligung jederzeit mit Wirkung für die Zukunft zu widerrufen (Art.&nbsp;7 Abs.&nbsp;3
          DSGVO).
        </p>
        <p>
          Zur Ausübung Ihrer Rechte können Sie sich jederzeit an den Verantwortlichen wenden:
          <a href="mailto:kontakt@wildfreigruen.de">kontakt@wildfreigruen.de</a>.
        </p>

        <h3>9. Beschwerderecht bei einer Aufsichtsbehörde</h3>
        <p>
          Darüber hinaus haben Sie das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren
          (Art.&nbsp;77 DSGVO), wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten
          gegen datenschutzrechtliche Bestimmungen verstößt.
        </p>
        <p>
          Für Brandenburg zuständig ist insbesondere:
        </p>
        <p>
          Die Landesbeauftragte für den Datenschutz und für das Recht auf Akteneinsicht Brandenburg<br>
          Stahnsdorfer Damm 77<br>
          14532 Kleinmachnow<br>
          Deutschland
        </p>

        <h3>10. Stand dieser Datenschutzerklärung</h3>
        <p>
          Diese Datenschutzerklärung ist aktuell gültig und hat den Stand: November 2025.
          Durch technische Weiterentwicklungen oder Änderungen gesetzlicher bzw. behördlicher Vorgaben
          kann eine Anpassung dieser Datenschutzerklärung erforderlich werden.
        </p>
      </section>
    </div>
    <PublicLegalFooter />
  </div>
</template>

<script setup>
import PublicLegalFooter from '@/components/layout/PublicLegalFooter.vue';
// statische Seite
</script>

<style scoped>
.legal-page {
  padding: 16px;
  background: var(--bg, #F6F7F9);
  color: var(--text, #1F2937);
  min-height: 100vh;
}

.page-header {
  border-bottom: 1px solid var(--border, #E0E3EA);
  padding-bottom: 8px;
  margin-bottom: 12px;
}

.h1 {
  font-size: 26px;
  line-height: 34px;
  font-weight: 600;
  margin: 0;
}

.h3 {
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  margin: 0 0 6px 0;
}

.mt-12 {
  margin-top: 12px;
}

.card {
  background: var(--surface, #FFFFFF);
  border: 1px solid var(--border, #E0E3EA);
  border-radius: 10px;
  padding: 16px;
  max-width: 840px;
}

.legal-page .card {
  max-width: none
}

a {
  color: var(--primary, #4F46E5);
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
</style>
